import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";

import queryString from "querystring";
import { CarService } from "../../../service/car-service";

const fetchBrandsSuccess = data => ({
    type: Types.FETCH_BRANDS_SUCCESS,
    data
});

const fetchBrandsFailure = error => ({
    type: Types.FETCH_BRANDS_FAILURE,
    error
});

const fetchBrands = () => dispatch => {
    CarService.fetchBrands()
        .then(response => {
            dispatch(fetchBrandsSuccess(response));
        })
        .catch(error => {
            dispatch(fetchBrandsFailure(error));
        });
};

const fetchModelsSuccess = data => ({
    type: Types.FETCH_MODELS_SUCCESS,
    data
});

const fetchModelsFailure = error => ({
    type: Types.FETCH_MODELS_FAILURE,
    error
});

const fetchModels = (makeId) => dispatch => {
    return CarService.fetchModels(makeId)
        .then(response => {
            dispatch(fetchModelsSuccess(response));
        })
        .catch(error => {
            dispatch(fetchModelsFailure(error));
        });
};

const fetchYearSuccess = years => ({
    type: Types.FETCH_YEAR_SUCCESS,
    years
});

const fetchYearFailure = error => ({
    type: Types.FETCH_YEAR_FAILURE,
    error
});

const fetchYears = (modelId) => dispatch => {
    return CarService.fetchYearList(modelId)
        .then(response => {
            dispatch(fetchYearSuccess(response.data.detail));
        })
        .catch(error => {
            dispatch(fetchYearFailure(error));
        });
};

const fetchVariantsSuccess = variants => ({
    type: Types.FETCH_VARIANTS_SUCCESS,
    variants
});

const fetchVariantsFailure = error => ({
    type: Types.FETCH_VARIANTS_FAILURE,
    error
});

const fetchVariants = ({ modelId, year }) => dispatch => {
    return CarService.fetchFuelVariant({ modelId, year })
        .then(response => {
            dispatch(fetchVariantsSuccess(response.data.detail));
        })
        .catch(error => {
            dispatch(fetchVariantsFailure(error));
        });
};

const fetchRegistrationStateSuccess = states => ({
    type: Types.FETCH_STATES_SUCCESS,
    states
});

const fetchRegistrationStateFailure = error => ({
    type: Types.FETCH_STATES_FAILURE,
    error
});

const fetchRegistrationState = () => dispatch => {
    return CarService.fetchStates()
        .then(response => {
            dispatch(fetchRegistrationStateSuccess(response.data.detail));
        })
        .catch(error => {
            dispatch(fetchRegistrationStateFailure(error));
        });
};

const resetSelections = () => ({
    type: Types.RESET_SELECTIONS
});

const updateSelectedBrand = (selectedBrand) => ({
    type: Types.UPDATE_SELECTED_BRAND,
    selectedBrand
});

const updateSelectedModel = (selectedModel) => ({
    type: Types.UPDATE_SELECTED_MODEL,
    selectedModel
});

const updateSelectedYear = (selectedYear) => ({
    type: Types.UPDATE_SELECTED_YEAR,
    selectedYear
});

const updateSelectedVariant = (selectedVariant) => ({
    type: Types.UPDATE_SELECTED_VARIANT,
    selectedVariant
});

const updateSelectedState = (selectedState) => ({
    type: Types.UPDATE_SELECTED_STATE,
    selectedState
});

const resetSpecifiedKey = (key) => ({
    type: Types.RESET_SPECIFIED_KEY,
    key
});

const makeLeadSuccess = (data) => ({
    type: Types.MAKE_LEAD_SUCCESS,
    data
});

const makeLeadFailure = (data) => ({
    type: Types.MAKE_LEAD_FAILURE,
    data
});

const makeLead = (query, payload) => (dispatch) => {
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.createLead(stringifiedQuery, payload)
            .then(response => {
                resolve(response.data.detail);
                dispatch(makeLeadSuccess(response.data.detail));
            })
            .catch(error => {
                reject(error);
                dispatch(makeLeadFailure(error));
            });
    });
};

const updateLead = (query, params) => (dispatch) => {
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateLead(stringifiedQuery, params).then(response => {
            resolve(response.data.detail);
            dispatch(makeLeadSuccess(response.data.detail));
        }).catch(error => {
            reject(error);
            dispatch(makeLeadFailure(error));
        });
    });
};

const fetchAllBranchCountSuccess = ({ total_branches: branch, total_cities: city }) => ({
    type: Types.FETCH_BRANCH_COUNT_SUCCESS,
    branch,
    city
});

const fetchAllBranchCountFailure = () => ({
    type: Types.FETCH_BRANCH_COUNT_FAILURE
});

const fetchAllBranchCount = () => dispatch => {
    return new Promise((resolve, reject) => {
        CarService.fetchAllBranchCounts().then(response => {
            dispatch(fetchAllBranchCountSuccess(response.data.detail));
            resolve(response.data.detail);
        }).catch(error => {
            dispatch(fetchAllBranchCountFailure());
            reject(error);
        });
    });
};

export {
    fetchBrands,
    fetchModels,
    fetchYears,
    fetchVariants,
    fetchRegistrationState,
    resetSelections,
    updateSelectedBrand,
    updateSelectedModel,
    updateSelectedYear,
    updateSelectedVariant,
    updateSelectedState,
    resetSpecifiedKey,
    makeLead,
    updateLead,
    fetchAllBranchCount
};
